function leftStickySection(options) {
  var $ = options.jQuery || window.jQuery;
  var scrollTriggerInstance = options.scrollTriggerInstance;
  var stickySections = [];
  var tocHeadingTriggers = [];
  var tocSections = [];
  var stickyResizeTimeout = null;
  var tocActiveOffset = 160;
  var tocMobileActiveOffset = 220;
  var tocScrollPadding = 12;
  var stickySectionConfigs = [
    {
      sectionSelector: ".section__tt__wrapper.text-left-sticky",
      leftSelector: ".column-tt-col.left",
      innerSelector: ".left-scroll-inner",
      start: "top 160px",
      endTriggerMode: "section-center",
    },
    {
      sectionSelector: ".single-post-template--has-toc",
      leftSelector: ".single-post-template__toc--desktop",
      innerSelector: "#ez-toc-container",
      start: "top 160px",
      endTriggerMode: "section-bottom-with-inner-offset",
      bottomTolerance: 80,
    },
  ];
  var stickyViewportQueries = [
    window.matchMedia("(max-width: 767px)"),
    window.matchMedia("(max-width: 991px)"),
  ];

  if (!$) {
    return;
  }

  function getStickyViewportQuery($section) {
    if ($section.hasClass("single-post-template--has-toc")) {
      return stickyViewportQueries[1];
    }

    return $section.hasClass("text-l-3-text-r-9")
      ? stickyViewportQueries[1]
      : stickyViewportQueries[0];
  }

  function setMobileTocAccordionState($container, isOpen) {
    var $toggle = $container.find(".ez-toc-title").first();
    var $nav = $container.find("nav").first();

    $container.toggleClass("is-open", isOpen);
    $toggle.attr("aria-expanded", isOpen ? "true" : "false");
    $nav.attr("aria-hidden", isOpen ? "false" : "true");
    $nav.prop("hidden", !isOpen);
  }

  function initMobileTocAccordion() {
    $(".single-post-template__toc-mobile #ez-toc-container-mobile").each(
      function (index) {
        var $container = $(this);
        var $titleContainer = $container.find(".ez-toc-title-container").first();
        var $toggle = $container.find(".ez-toc-title").first();
        var $nav = $container.find("nav").first();
        var navId;

        if (!$titleContainer.length || !$toggle.length || !$nav.length) {
          return;
        }

        if ($container.attr("data-mobile-toc-accordion-bound") === "true") {
          return;
        }

        navId = $nav.attr("id") || "ez-toc-container-mobile-nav-" + index;
        $nav.attr("id", navId);
        $toggle.attr({
          role: "button",
          tabindex: "0",
          "aria-controls": navId,
        });

        setMobileTocAccordionState($container, false);
        $container.attr("data-mobile-toc-accordion-bound", "true");

        $titleContainer.on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          setMobileTocAccordionState($container, !$container.hasClass("is-open"));
        });

        $titleContainer.on("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") {
            return;
          }

          event.preventDefault();
          setMobileTocAccordionState($container, !$container.hasClass("is-open"));
        });

        $nav[0].addEventListener(
          "click",
          function (event) {
            if (
              !event.target ||
              typeof event.target.closest !== "function" ||
              !event.target.closest("a")
            ) {
              return;
            }

            window.setTimeout(function () {
              setMobileTocAccordionState($container, false);
            }, 0);
          },
          true,
        );
      },
    );
  }

  function resetStickyInnerStyles($inner) {
    $inner.css({
      width: "",
      boxSizing: "",
      paddingRight: "",
    });
  }

  function getTocActiveOffset() {
    return stickyViewportQueries[1].matches
      ? tocMobileActiveOffset
      : tocActiveOffset;
  }

  function getTocHeadingStart() {
    return "top " + getTocActiveOffset() + "px";
  }

  function getTocLinkSelector() {
    return stickyViewportQueries[1].matches
      ? ".single-post-template__toc-mobile #ez-toc-container-mobile ul a[href^='#']"
      : ".single-post-template__toc--desktop #ez-toc-container ul a[href^='#']";
  }

  function getTocHeadingId(hash) {
    var headingId;

    if (typeof hash !== "string" || hash.charAt(0) !== "#") {
      return "";
    }

    headingId = hash.slice(1);

    if (!headingId.length) {
      return "";
    }

    try {
      return decodeURIComponent(headingId);
    } catch (error) {
      return headingId;
    }
  }

  function resetTocSectionState(tocSection) {
    tocSection.items.forEach(function (item) {
      item.$item.removeClass("is-active");
      item.$link.removeAttr("aria-current");
    });
  }

  function isScrollableTocElement(element) {
    var overflowY;

    if (!element || element === document.body) {
      return false;
    }

    overflowY = window.getComputedStyle(element).overflowY;

    return (
      (overflowY === "auto" || overflowY === "scroll") &&
      element.scrollHeight > element.clientHeight
    );
  }

  function scrollTocItemIntoContainerView(itemElement, container) {
    var containerRect = container.getBoundingClientRect();
    var itemRect = itemElement.getBoundingClientRect();
    var topOverflow = containerRect.top + tocScrollPadding - itemRect.top;
    var bottomOverflow = itemRect.bottom - (containerRect.bottom - tocScrollPadding);

    if (topOverflow > 0) {
      container.scrollTop -= topOverflow;
      return;
    }

    if (bottomOverflow > 0) {
      container.scrollTop += bottomOverflow;
    }
  }

  function scrollActiveTocItemIntoView(activeItem) {
    var itemElement = activeItem.$item[0];
    var element = itemElement ? itemElement.parentElement : null;
    var scrolled = false;
    var fallbackContainer;

    if (!itemElement) {
      return;
    }

    while (element && element !== document.body) {
      if (isScrollableTocElement(element)) {
        scrollTocItemIntoContainerView(itemElement, element);
        scrolled = true;
      }

      if (
        element.id === "ez-toc-container" ||
        element.id === "ez-toc-container-mobile"
      ) {
        break;
      }

      element = element.parentElement;
    }

    if (scrolled) {
      return;
    }

    fallbackContainer = activeItem.$item.closest("ul")[0];

    if (fallbackContainer) {
      scrollTocItemIntoContainerView(itemElement, fallbackContainer);
    }
  }

  function setActiveTocItem(tocSection, activeItem) {
    tocSection.items.forEach(function (item) {
      var isActive = item === activeItem;

      item.$item.toggleClass("is-active", isActive);

      if (isActive) {
        item.$link.attr("aria-current", "location");
      } else {
        item.$link.removeAttr("aria-current");
      }
    });

    scrollActiveTocItemIntoView(activeItem);
  }

  function syncTocSectionState(tocSection) {
    var activeItem = null;

    if (
      tocSection.content.getBoundingClientRect().bottom <= getTocActiveOffset()
    ) {
      resetTocSectionState(tocSection);
      return;
    }

    tocSection.items.forEach(function (item) {
      if (item.heading.getBoundingClientRect().top <= getTocActiveOffset()) {
        activeItem = item;
      }
    });

    if (activeItem) {
      setActiveTocItem(tocSection, activeItem);
      return;
    }

    resetTocSectionState(tocSection);
  }

  function destroyTocHeadingTriggers() {
    tocHeadingTriggers.forEach(function (tocHeadingTrigger) {
      tocHeadingTrigger.kill();
    });

    tocSections.forEach(function (tocSection) {
      resetTocSectionState(tocSection);
    });

    tocHeadingTriggers = [];
    tocSections = [];
  }

  function getTocItems($section) {
    var $content = $section.find(".wp_post__content").first();
    var items = [];
    var seenHeadingIds = {};

    if (!$content.length) {
      return items;
    }

    $section.find(getTocLinkSelector()).each(function () {
      var headingId = getTocHeadingId(this.getAttribute("href"));
      var heading;
      var $item;

      if (!headingId.length || seenHeadingIds[headingId]) {
        return;
      }

      heading = document.getElementById(headingId);

      if (!heading || !$content[0].contains(heading)) {
        return;
      }

      $item = $(this).closest("li");

      if (!$item.length) {
        return;
      }

      seenHeadingIds[headingId] = true;

      items.push({
        heading: heading,
        $item: $item,
        $link: $(this),
      });
    });

    return items;
  }

  function initTocActiveStates() {
    destroyTocHeadingTriggers();

    $(".single-post-template--has-toc").each(function () {
      var $section = $(this);
      var $content = $section.find(".wp_post__content").first();
      var tocItems = getTocItems($section);
      var tocSection;

      if (!$content.length || !tocItems.length) {
        return;
      }

      tocSection = {
        items: tocItems,
        content: $content[0],
      };

      tocSections.push(tocSection);

      tocItems.forEach(function (item, index) {
        var nextItem = tocItems[index + 1] || null;

        tocHeadingTriggers.push(
          scrollTriggerInstance.create({
            trigger: item.heading,
            start: getTocHeadingStart(),
            endTrigger: nextItem ? nextItem.heading : tocSection.content,
            end: nextItem
              ? getTocHeadingStart()
              : "bottom " + getTocActiveOffset() + "px",
            invalidateOnRefresh: true,
            onEnter: function () {
              setActiveTocItem(tocSection, item);
            },
            onEnterBack: function () {
              setActiveTocItem(tocSection, item);
            },
            onLeaveBack: function () {
              if (index === 0) {
                resetTocSectionState(tocSection);
              }
            },
            onLeave: function () {
              if (!nextItem) {
                resetTocSectionState(tocSection);
              }
            },
          }),
        );
      });

      syncTocSectionState(tocSection);
    });
  }

  function setStickyInnerWidth($left, $inner) {
    var rect = $left[0].getBoundingClientRect();

    $inner.css({
      width: rect.width + "px",
      boxSizing: "border-box",
      paddingRight: "24px",
    });
  }

  function destroyStickySectionAnimations() {
    stickySections.forEach(function (stickySection) {
      if (stickySection.scrollTrigger) {
        stickySection.scrollTrigger.kill();
      }

      resetStickyInnerStyles(stickySection.$inner);
    });

    stickySections = [];
    destroyTocHeadingTriggers();
  }

  function getStickyTriggerConfig(config, $section, $left, $inner) {
    var triggerConfig = {
      trigger: $left[0],
      start: config.start || "top 160px",
      pin: $inner[0],
      pinSpacing: false,
      anticipatePin: 0,
      invalidateOnRefresh: false,
    };

    if (config.endTriggerMode === "section-bottom-with-inner-offset") {
      triggerConfig.endTrigger = $section[0];
      triggerConfig.end = function () {
        return (
          "bottom top+=" +
          (160 + $inner.outerHeight() + (config.bottomTolerance || 0))
        );
      };
      triggerConfig.invalidateOnRefresh = true;

      return triggerConfig;
    }

    triggerConfig.endTrigger = $section[0];
    triggerConfig.end = "bottom center";

    return triggerConfig;
  }

  function initStickySectionAnimations() {
    destroyStickySectionAnimations();

    stickySectionConfigs.forEach(function (config) {
      $(config.sectionSelector).each(function () {
        var $section = $(this);
        var $left = $section.find(config.leftSelector).first();
        var $inner;
        var stickyViewportQuery;

        if (!$left.length) {
          return;
        }

        $inner = $left.find(config.innerSelector).first();

        if (!$inner.length) {
          return;
        }

        stickyViewportQuery = getStickyViewportQuery($section);

        if (stickyViewportQuery.matches) {
          resetStickyInnerStyles($inner);
          return;
        }

        stickySections.push({
          scrollTrigger: scrollTriggerInstance.create(
            getStickyTriggerConfig(config, $section, $left, $inner),
          ),
          $inner: $inner,
        });
      });
    });

    initTocActiveStates();
  }

  function handleStickySectionResize() {
    window.clearTimeout(stickyResizeTimeout);

    stickyResizeTimeout = window.setTimeout(function () {
      initStickySectionAnimations();
      scrollTriggerInstance.refresh(true);
    }, 150);
  }

  function bindStickySectionAssetRefresh() {
    stickySectionConfigs.forEach(function (config) {
      $(config.sectionSelector)
        .find("img")
        .each(function () {
          var image = this;

          if (image.getAttribute("data-sticky-refresh-bound") === "true") {
            return;
          }

          image.setAttribute("data-sticky-refresh-bound", "true");

          if (image.complete) {
            return;
          }

          image.addEventListener("load", handleStickySectionResize, {
            once: true,
          });
          image.addEventListener("error", handleStickySectionResize, {
            once: true,
          });
        });
      });
  }

  if (!scrollTriggerInstance) {
    initMobileTocAccordion();
    return;
  }

  initStickySectionAnimations();
  bindStickySectionAssetRefresh();
  initMobileTocAccordion();

  window.addEventListener("resize", handleStickySectionResize);

  stickyViewportQueries.forEach(function (stickyViewportQuery) {
    if (typeof stickyViewportQuery.addEventListener === "function") {
      stickyViewportQuery.addEventListener("change", handleStickySectionResize);
    } else if (typeof stickyViewportQuery.addListener === "function") {
      stickyViewportQuery.addListener(handleStickySectionResize);
    }
  });
}

module.exports = leftStickySection;
